export const homeServiceMapper = (data) => ({
    id: data.id,
    nameIt: data.nameIt,
    group: data.group,
})